import { IMenu } from '../../../stores/layout.store';

export const ProductMenus: IMenu[] = [
  {
    icon: 'icon-[mdi--view-dashboard-outline]',
    name: '대시보드',
    href: 'dashboard',
  },
  {
    icon: 'icon-[mdi--pig-variant-outline]',
    name: '돼지 관리',
    href: 'pig',
  },
  {
    icon: 'icon-[mdi--receipt-text]',
    name: '주문 관리',
    href: 'order',
  },
  {
    icon: 'icon-[material-symbols--gallery-thumbnail-outline]',
    name: '갤러리 관리',
    href: 'growth-gallery',
  },
];
